// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bannerBackground {
  background-color: #75adde;
  box-shadow: 0 0 2px 2px rgb(0 0 0/40%);
}

.ezBannerImage {
  max-width: 1513px;
  max-height: 288px;
  width: 100%;
  height: auto;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
@media screen and (max-width: 1024px) {
  h1 {
    font-size: var(--ezTitleFontSize);
  }
  h3 {
    font-size: var(--ezTopicFontSize);
  }
  h4 {
    font-size: var(--ezFontSize);
  }
}
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
@media screen and (max-width: 768px) {
  h1 {
    font-size: var(--ezTitleFontSize);
  }
  h3 {
    font-size: var(--ezTopicFontSize);
  }
  h4 {
    font-size: var(--ezFontSize);
  }
}
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
@media screen and (max-width: 480px) {
  h1 {
    font-size: var(--ezTitleFontSize);
  }
  h3 {
    font-size: var(--ezTopicFontSize);
  }
  h4 {
    font-size: var(--ezFontSize);
  }
}
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
@media screen and (max-width: 319px) {
  h1 {
    font-size: var(--ezTitleFontSize);
  }
  h3 {
    font-size: var(--ezTopicFontSize);
  }
  h4 {
    font-size: var(--ezFontSize);
  }
}`, "",{"version":3,"sources":["webpack://./public/tos/tos-2022.05.01.css"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,sCAAA;AACJ;;AAEA;EACI,iBAAA;EACA,iBAAA;EAEA,WAAA;EACA,YAAA;AAAJ;;AAIA;;qEAAA;AAGA;EACI;IACI,iCAAA;EADN;EAGE;IACI,iCAAA;EADN;EAGE;IACI,4BAAA;EADN;AACF;AAIA;;qEAAA;AAGA;EACI;IACI,iCAAA;EAFN;EAIE;IACI,iCAAA;EAFN;EAIE;IACI,4BAAA;EAFN;AACF;AAKA;;qEAAA;AAGA;EACI;IACI,iCAAA;EAHN;EAKE;IACI,iCAAA;EAHN;EAKE;IACI,4BAAA;EAHN;AACF;AAMA;;qEAAA;AAGA;EACI;IACI,iCAAA;EAJN;EAME;IACI,iCAAA;EAJN;EAME;IACI,4BAAA;EAJN;AACF","sourcesContent":[".bannerBackground {\r\n    background-color: #75adde;\r\n    box-shadow: 0 0 2px 2px rgb(0 0 0 / 40%);\r\n}\r\n\r\n.ezBannerImage {\r\n    max-width: 1513px;\r\n    max-height: 288px;\r\n\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 1024px) {\r\n    h1 {\r\n        font-size: var(--ezTitleFontSize);\r\n    }\r\n    h3 {\r\n        font-size: var(--ezTopicFontSize);\r\n    }\r\n    h4 {\r\n        font-size: var(--ezFontSize);\r\n    }\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 768px) {\r\n    h1 {\r\n        font-size: var(--ezTitleFontSize);\r\n    }\r\n    h3 {\r\n        font-size: var(--ezTopicFontSize);\r\n    }\r\n    h4 {\r\n        font-size: var(--ezFontSize);\r\n    }\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 480px) {\r\n    h1 {\r\n        font-size: var(--ezTitleFontSize);\r\n    }\r\n    h3 {\r\n        font-size: var(--ezTopicFontSize);\r\n    }\r\n    h4 {\r\n        font-size: var(--ezFontSize);\r\n    }\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 319px) {\r\n    h1 {\r\n        font-size: var(--ezTitleFontSize);\r\n    }\r\n    h3 {\r\n        font-size: var(--ezTopicFontSize);\r\n    }\r\n    h4 {\r\n        font-size: var(--ezFontSize);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
